import(/* webpackMode: "eager" */ "/vercel/path0/src/app/case-studies/page.tsx");
